import { render } from "./Welcome.vue?vue&type=template&id=6199525e"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=6199525e&lang=css"

import exportComponent from "/Users/nori/Dropbox (Nakajima Glass)/ngciio/ngci-members/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__